import getWindow from "./window";
// For use of checking existence of elements outside React codebase

export default function whenElementExists(elementSelector, root, callbackFunc) {
  let elementNode;

  elementNode = getWindow().document.querySelector(elementSelector);
  if (elementNode) {
    callbackFunc(elementNode);
    return () => {};
  }

  const mutationObserver = getWindow().MutationObserver;

  const observer = new mutationObserver(() => {
    elementNode = getWindow().document.querySelector(elementSelector);
    if (elementNode) {
      observer.disconnect();
      callbackFunc(elementNode);
    }
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}
